import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Stack,
  Typography
} from '@mui/material'
import { SystemModule } from '@/core/types/SystemModule.ts'

interface Props {
  onClick?: () => void
  module: SystemModule
}

const HomeModule = ({ module, onClick }: Props) => {
  return (
    <Card sx={{ width: '155px', display: 'flex' }}>
      <CardActionArea onClick={onClick}>
        <CardContent sx={{ display: 'flex', justifyContent: 'center' }}>
          <Stack sx={{ textAlign: 'center' }}>
            <Box component="img" src={module.icon}></Box>
            <Typography variant="body2" color="text.secondary">
              {module.name}
            </Typography>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export default HomeModule
